<template>
  <div>
    <div class="text-h6 mt-2 mb-3 d-block d-md-none">
      <v-icon color="grey" style="margin-bottom: 3px;">mdi-account</v-icon> {{ $t('my-account') }}
    </div>
    <v-row>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-form v-model="form.valid">
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field filled :label="$t('fields.first_name') + '*'" v-model="form.fields.first_name"
                                :rules="form.rules.first_name" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field filled :label="$t('fields.last_name') + '*'" v-model="form.fields.last_name"
                                :rules="form.rules.last_name" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field filled :label="$t('fields.company')" v-model="form.fields.company"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field disabled filled :label="$t('fields.email') + '*'" v-model="form.fields.email"></v-text-field>
                  <div style="text-align: right; margin-top: -25px;">
                    <v-btn text disabled>{{ $t('actions.edit') }}</v-btn>
                  </div>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field disabled filled value="mypassword" :label="$t('fields.password') + '*'" type="password"></v-text-field>
                  <div style="text-align: right; margin-top: -25px;">
                    <v-btn text @click="password.visible = true">{{ $t('actions.edit') }}</v-btn>
                  </div>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn class="primary" :loading="form.loading" @click="submit">{{ $t('actions.save') }}</v-btn>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn style="opacity: 0.7" small color="error" @click="remove.visible = true" text>{{ $t('delete-my-account') }}</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
        <v-dialog v-model="password.visible" persistent max-width="450px">
            <v-card>
              <v-card-title>
                <span class="headline">Modification du mot de passe</span>
              </v-card-title>
              <v-card-text>
                <v-form v-model="password.form.valid" class="mt-4">
                  <v-text-field
                    v-model="password.form.fields.password"
                    :rules="password.form.rules.password" type="password"
                    label="Mot de passe"
                    required></v-text-field>
                  <v-text-field
                    v-model="password.form.fields.password_confirmation"
                    :rules="password.form.rules.password_confirmation" type="password"
                    label="Confirmation du mot de passe"
                    required></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="password.visible = false">Annuler</v-btn>
                <v-btn color="blue darken-1" text :loading="password.loading" @click="changePassword">Modifier</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        <v-dialog v-model="remove.visible" persistent max-width="450px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ $t('delete-dialog-title') }}</span>
              </v-card-title>
              <v-card-text>
                {{ $t('delete-dialog-content') }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="remove.visible = false">{{ $t('actions.cancel') }}</v-btn>
                <v-btn color="error" text :loading="password.loading" @click="deleteAccount">{{ $t('actions.remove') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ProfilePage',
  data () {
    return {
      form: {
        valid: false,
        loading: false,
        fields: {
          first_name: null,
          last_name: null,
          company: null,
          email: null,
        },
        rules: {
          first_name: [v => !!v || 'Le prénom est requis.'],
          last_name: [v => !!v || 'Le nom est requis.'],
        }
      },
      password: {
        visible: false,
        loading: false,
        form: {
          valid: false,
          fields: {
            password: '',
            password_confirmation: ''
          },
          rules: {
            password: [
              v => !!v || 'Un mot de passe est requis.',
              v => v.length >= 8 || 'Votre mot de passe doit contenir au moins 8 caractères.',
            ],
            password_confirmation: [
              v => !!v || 'Un mot de passe est requis.',
              v => (v === this.password.form.fields.password) || 'Les mots de passe doivent correspondre.'
            ],
          }
        }
      },
      remove: {
        visible: false
      }
    }
  },
  methods: {
    changePassword () {
      this.password.loading = true
      this.$account.update(this.password.form.fields)
        .then(() => {
          this.password.loading = false
          this.password.visible = false
          this.password.form.fields.password = ''
          this.password.form.fields.password_confirmation = ''
          this.$ui.success('Mot de passe modifié.')
        })
        .catch(() => {
          this.password.loading = false
        })
    },
    submit () {
      this.form.loading = true
      this.$account.update(this.form.fields)
        .then(() => {
          this.form.loading = false
          this.$ui.success('Modifications enregistrées.')
        })
        .catch(() => {
          this.form.loading = false
        })
    },
    async deleteAccount() {
      await this.$api.post('/account/remove')
      this.$account.logout()
      this.$router.push('/login')
    }
  },
  mounted () {
    const user = this.$account.current

    this.form.fields.first_name = user.first_name
    this.form.fields.last_name = user.last_name
    this.form.fields.company = user.company
    this.form.fields.email = user.email
  }
}
</script>

<i18n>
{
	"en": {
		"delete-dialog-content": "Are you sure you want to delete your account? This action is irreversible, all data will be permanently lost.",
		"delete-dialog-title": "Permanent deletion of my account",
		"delete-my-account": "Delete my account",
		"fields": {
			"company": "Company",
			"email": "Email",
			"first_name": "First name",
			"last_name": "Last name",
			"password": "Password"
		},
		"my-account": "My account"
	},
	"es": {
		"delete-dialog-content": "¿Estás seguro de que deseas eliminar tu cuenta? Esta acción es irreversible, todos los datos se perderán de forma permanente.",
		"delete-dialog-title": "Eliminación permanente de mi cuenta",
		"delete-my-account": "Borrar mi cuenta",
		"fields": {
			"company": "Empresa",
			"email": "Email",
			"first_name": "Nombre de pila",
			"last_name": "Apellido",
			"password": "Contraseña"
		},
		"my-account": "Mi cuenta"
	},
	"fr": {
		"delete-dialog-content": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible, toutes les données seront définitivement perdues.",
		"delete-dialog-title": "Suppression définitive du compte",
		"delete-my-account": "Supprimer mon compte",
		"fields": {
			"company": "Entreprise",
			"email": "Email",
			"first_name": "Prénom",
			"last_name": "Nom",
			"password": "Mot de passe"
		},
		"my-account": "Mon Compte"
	},
	"it": {
		"delete-dialog-content": "Sei sicuro di voler eliminare il tuo account? Questa azione è irreversibile, tutti i dati verranno persi definitivamente.",
		"delete-dialog-title": "Eliminazione definitiva del mio account",
		"delete-my-account": "Elimina il mio account",
		"fields": {
			"company": "Azienda",
			"email": "Email",
			"first_name": "Nome",
			"last_name": "Cognome",
			"password": "Password"
		},
		"my-account": "Il mio account"
	},
	"pt": {
		"delete-dialog-content": "Tem a certeza de que deseja eliminar a sua conta? Esta ação é irreversível, todos os dados serão perdidos permanentemente.",
		"delete-dialog-title": "Eliminação permanente da minha conta",
		"delete-my-account": "Eliminar a minha conta",
		"fields": {
			"company": "Empresa",
			"email": "Email",
			"first_name": "Nome próprio",
			"last_name": "Apelido",
			"password": "Palavra-passe"
		},
		"my-account": "A minha conta"
	},
	"pl": {
		"delete-dialog-content": "Czy na pewno chcesz usunąć swoje konto? Ta akcja jest nieodwracalna, wszystkie dane zostaną trwale utracone.",
		"delete-dialog-title": "Trwałe usunięcie mojego konta",
		"delete-my-account": "Usuń moje konto",
		"fields": {
			"company": "Firma",
			"email": "Email",
			"first_name": "Imię",
			"last_name": "Nazwisko",
			"password": "Hasło"
		},
		"my-account": "Moje konto"
	}
}
</i18n>
